import { TestProps } from "../../../types";
import { IconName } from "../at-icon";

export enum AtButtonType {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  TERTIARY = "tertiary",
  ICON = "icon",
  BREADCRUMB = "breadcrumb",
  PRIMARY_RED = "primaryRed",
  SECONDARY_RED = "secondaryRed",
}

export enum AtButtonSize {
  EXTRA_SMALL = "extraSmall",
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
  NONE = "none",
  CUSTOM = "custom",
}

export interface AtButtonProps
  extends TestProps, React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  buttonType?: AtButtonType;
  size?: AtButtonSize;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  startIcon?: IconName;
  href?: string;
  onClick?: () => void;
  type?: "submit" | "button" | "reset";
  style?: React.CSSProperties;
  iconSize?: number;
}
